import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSelfOperatingReleaseValve = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 104.97,
	height: 104.92,
	viewBox: "0 0 104.97 104.92",
	...props,
	children: [/* @__PURE__ */ _jsx("ellipse", {
		cx: 50,
		cy: 50,
		rx: 50,
		ry: 50,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 85.4 14.6 A 50.0 50.0 0.0 1 1 14.7 85.4 Z",
		fill: "#000000",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgSelfOperatingReleaseValve;
